"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function isOnlyNumberInString(str) {
    if (lodash_1.isUndefined(str) || str === '')
        return false;
    return !lodash_1.isNaN(+str);
}
exports.default = isOnlyNumberInString;
//# sourceMappingURL=isOnlyNumberInString.js.map